/* eslint-disable */
/**
 * Capture the index page so that it can be redirected
 * @export
 */
export const INDEX_PAGE_PATH_REDIRECT = `/index.html`;

/**
 * The path of the `HomePage` to be consumed by a `<Router />`
 * @export
 */
export const HOME_PAGE_PATH = `/`;

/**
 * Create a `href` that will resolve to `HomePage`
 * @export
 * @returns {string} The `HOME_PAGE_PATH`
 */
export const createHomePageLink = () => HOME_PAGE_PATH;

/**
 * Determine if the current page is the `HomePage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `HomePage`
 */
export const isHomePage = (match) => match.path === HOME_PAGE_PATH;
